<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic-id exCollection="mappingExCollection" refCollection="" @ready="onReady" @error="onError"
          @saved="onSaved" @savedNext="onSavedNext" @loadedEx="onLoadedEx" @modifyEx="onModifyEx"
          @loadedRef="onLoadedRef" :saveState="saveState" :doc="doc" :shared="false" :projectShared="false" :pid="true"
          :eid="$route.params.eid" :synced="false">
          <template slot-scope="{ saveExercise, doc }">
            <v-row>
              <v-col cols="12" class="mb-4">
                <div class="d-flex justify-space-between">
                  <h2 class="headline">Mapping</h2>
                </div>
              </v-col>

              <v-col cols="12" class="mb-4">
                <v-card dark>
                  <v-card-text>
                    <div class="d-flex justify-start align-center">
                      <v-text-field label="Title" v-model.trim="doc.title" type="text" required :hide-details="false"
                        color="amber" class="flex-grow-0 mr-8"></v-text-field>
                      <v-select :items="['Map', 'Image']" label="Map type" v-model="doc.mapMode"
                        class="flex-grow-0 mr-8"></v-select>

                      <v-switch v-model="doc.locked" inset label="Lock Markers" class="flex-grow-0 mr-8"></v-switch>

                      <v-switch v-model="doc.side" inset label="Show sidebar" class="flex-grow-0 mr-8"></v-switch>

                      <v-btn outlined @click="doc.showSettings = !doc.showSettings" class="ml-2 flex-grow-0"
                        small><v-icon small class="mr-2">mdi-cog</v-icon>{{ settingsLabel }}</v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card v-if="doc.showSettings">
                  <v-card-title>
                    Document settings
                  </v-card-title>
                  <v-card-text>
                    <v-text-field label="Lng" v-model.trim="doc.lng" type="text" required :hide-details="false"
                      color="amber"></v-text-field>
                    <v-text-field label="Lat" v-model.trim="doc.lat" type="text" required :hide-details="false"
                      color="amber"></v-text-field>
                    <v-select label="Marker radius" v-model.trim="doc.radius" :items="['Sm', 'Md', 'Rg', 'Lg', 'Xl']" />
                  </v-card-text>
                </v-card>
                <UnitImage v-if="doc.showSettings" class="mb-3" v-model="doc.image" :props="{ title: 'Map image' }"
                  :show-preview="false" @input="imgLoaded = true" />
              </v-col>
              <v-col v-if="doc.showSettings" cols="6">
                <v-card dark>
                  <v-card-title>
                    Categories
                  </v-card-title>
                  <v-card-text>
                    <unit-sub-items v-model="doc.categorySource" name="sub">
                      <v-label><span class="black--text">Define the category of sign</span></v-label>
                      <p class="ma-0">
                        Type below and press <strong>Add</strong>
                      </p>
                    </unit-sub-items>

                    <unit-sub-items v-model="doc.zoneSource" name="sub" class="mt-2">
                      <v-label><span class="black--text">Define the type of the sign</span></v-label>
                      <p class="ma-0">
                        Type below and press <strong>Add</strong>
                      </p>
                    </unit-sub-items>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-sheet class="mt-4">
              <div class="pa-4 relative">
                <v-row>
                  <v-col :cols="sideMode ? 9 : 12">
                    <div class="d-flex justify-space-between">
                      <v-select class="mr-10 pt-0" :items="['', ...doc.zoneSource]" label="Category"
                        v-model="filters.zones" required></v-select>
                      <v-select class="mr-10 pt-0" :items="['', ...doc.categorySource]" label="Type"
                        v-model="filters.categories" required></v-select>

                      <v-btn light outlined color="grey lighten-2" class="mr-1" @click="changeSort('type')">By
                        type</v-btn>
                      <v-btn light outlined color="grey lighten-2" class="mr-1" @click="changeSort('zone')">By
                        zone</v-btn>
                      <v-btn light outlined color="grey lighten-2" class="mr-1" @click="changeSort('asc')">A-Z</v-btn>
                      <v-btn light outlined color="grey lighten-2" class="mr-1" @click="changeSort('desc')">Z-A</v-btn>
                    </div>

                    <MappingImage v-if="doc.mapMode === 'Image'" :items="filterListType(doc.items)" :exercise="doc"
                      :radius="doc.radius" :key="`image-${doc.items.length}-${modify}`" :image="doc.image"
                      :imgLoaded="imgLoaded" :resizeProp="resizeProp" :locked="doc.locked" :class="{ sticky: sideMode }"
                      @update="updatedCoords" @saveNormalise="saveNormalise" @showNote="showNote" />

                    <template v-else>
                      <MappingMap v-if="doc && center" :items="filterListType(doc.items)" :all="doc.items"
                        :exercise="doc" :key="`map-${doc.items.length}`" :locked="doc.locked" :center="{
                          lat: center.lat,
                          lng: center.lng
                        }" :class="{ sticky: sideMode }" @updatedLngLat="updatedLngLat" @showNote="showNote" />
                    </template>

                    <!-- Order by type  -->
                  </v-col>

                  <v-col :cols="doc.side ? 3 : 12" :class="{ mapping__side__panel: sideMode }">
                    <div v-if="sideMode">
                      <v-btn @click="addNote" color="amber" class="ma-0 mb-4" light>Add Sign</v-btn>
                    </div>

                    <div class="d-flex justify-space-between">
                      <v-btn v-if="!sideMode" @click="addNote" color="amber" class="ma-0" light>Add Sign</v-btn>
                    </div>

                    <div v-if="doc.sortMode === 'type'">
                      <div v-for="a in Object.entries(grouped)" :key="a[0]">
                        <h2 class="text-headline">{{ a[0] }}</h2>
                        <v-row>
                          <v-col v-for="card in a[1]" :key="card.id" :cols="sideMode ? 12 : 3">
                            <MappingCard :card="card" @editNote="editNote" @showNote="showNote"
                              @deleteNote="deleteNote" />
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                    <div v-else-if="doc.sortMode === 'zone'">
                      <div v-for="a in Object.entries(zoned)" :key="a[0]">
                        <h2 class="text-headline">{{ a[0] }}</h2>
                        <v-row>
                          <v-col v-for="card in a[1]" :key="card.id" :cols="sideMode ? 12 : 3">
                            <MappingCard :card="card" @editNote="editNote" @showNote="showNote"
                              @deleteNote="deleteNote" />
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                    <v-row v-else>
                      <v-col v-for="card in sorted" :key="card.id" :cols="sideMode ? 12 : 3">
                        <MappingCard :card="card" @editNote="editNote" @showNote="showNote" @deleteNote="deleteNote" />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-sheet>

            <bottom-navigation v-if="doc" :save="true" :next="false" :prev="false" :gridView="false" :gridToggle="false"
              :list="`mapping`" @save="saveExercise(true)" @prev="prevStep" @next="saveExercise(false)">
            </bottom-navigation>
          </template>
        </exercise-logic-id>
      </v-col>
    </v-row>

    <v-dialog v-if="content" v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add item</v-card-title>
        <v-card-text>
          <mapping-add :doc="item" :categories="doc.categorySource" :zones="doc.zoneSource" @saveNote="saveNote"
            @cancel="cancel" />
        </v-card-text>
      </v-card>

      <v-card v-else-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <mapping-show :doc="item" :key="cardId" :categories="doc.categorySource" :zones="doc.zoneSource"
            @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-else-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit item</v-card-title>

        <v-card-text>
          <mapping-edit :doc="item" :categories="doc.categorySource" :zones="doc.zoneSource" :key="cardId"
            @updateNote="updateNote" @cancel="cancel" />
        </v-card-text>
      </v-card>

      <v-card v-else-if="dialogMode == 'delete'">
        <v-card-title class="headline">Delete item</v-card-title>

        <v-card-text class="pa-10">Are you sure you want to remove this item?
        </v-card-text>
        <v-card-actions>
          <v-btn class="mt-5" @click="deleteNoteConfirm">Delete</v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'save'">
        <v-card-title class="headline">
          <!-- {{ content.exercise_mapping.saved.title }} -->
          Saving exercise
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const defaults = {
  title: "",
  categories: [],
  subitems: [],
  description: "",
  x: 0,
  y: 0,
  position: { lat: 0, lng: 0 },
};

// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicId } from "@/components/exercises";
import {
  MappingImage,
  MappingAdd,
  MappingEdit,
  MappingShow,
  MappingCard,
  MappingMap,
} from "@/views/user/exercises/mapping";

import { UnitImage, UnitSubItems } from "@/components/units";

import EventBus from "@/utils/eventbus";

import lodash from "lodash";
// import { Isotope } from "@/vendor";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserMapping",

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },

  data() {
    return {
      e1: 1,
      content: null,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: "add",
      revision: 1,
      modify: 1,
      cardIndex: null,
      cardId: null,
      saveState: false,
      autoSave: true,
      resizeProp: 1,
      filters: {
        zones: "",
        categories: "",
      },
      doc: {
        showSettings: false,
        title: "",
        items: [],
        image: "",
        sortMode: "asc",
        mapMode: "Image",
        categorySource: [],
        lat: 40.86813428624537,
        lng: -73.55285762429068,
        locked: false,
        side: false,
        zoneSource: [],
      },
      items: [],
      item: null,
      listLength: 1,
      debug: false,
      imgLoaded: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicId,
    MappingImage,
    MappingAdd,
    MappingEdit,
    MappingShow,
    MappingCard,
    MappingMap,
    UnitImage,
    UnitSubItems,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    settingsLabel() {
      return this.doc.showSettings ? "Hide settings" : "Show settings";
    },
    grouped() {
      return this.doc
        ? lodash.groupBy(this.filterListType(this.doc.items), "categories")
        : [];
    },
    zoned() {
      return this.doc
        ? lodash.groupBy(this.filterListType(this.doc.items), "zones")
        : [];
    },
    sorted() {
      if (this.doc.sortMode === "asc") {
        return this.doc
          ? lodash.orderBy(this.filterListType(this.doc.items), "code", "asc")
          : [];
      } else {
        return this.doc
          ? lodash.orderBy(this.filterListType(this.doc.items), "code", "desc")
          : [];
      }
    },
    sideMode() {
      return this.doc.side;
    },
    center() {
      return this.doc && this.doc.lat && this.doc.lng ? {
        lat: parseFloat(this.doc.lat),
        lng: parseFloat(this.doc.lng)
      } : {}
    }
  },
  watch: {
    doc: {
      deep: true,
      handler() {
        this.revision++;
      },
    },
    sideMode() {
      this.resizeProp++;
      console.log("sidemode changed", this.resizeProp);
    },
  },
  mounted() { },
  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() { },
    onError() {
      console.log("error");
    },
    onSaved() {
      this.dialog = true;
      this.dialogMode = "save";
    },
    onLoadedRef(refs) {
      if (refs) {
        this.refs = refs[0];
      }
    },
    onLoadedEx(items) {
      console.log("loaded exercise", items);
      if (items) {
        this.mergeArrays(items[0].doc);
        EventBus.$emit("image:loaded");
      }
    },
    onModifyEx(items) {
      if (items) {
        this.exercises = [...items];
      }
    },
    onSavedNext() {
      this.nextStep();
    },
    changeSort(sort) {
      this.doc.sortMode = sort;
    },
    addNote() {
      // set the base item to defaults
      this.item = { ...defaults };
      this.$set(this.item, "subitems", []);
      this.dialogMode = "add";
      this.dialog = true;
    },
    saveNote(ref) {
      // create a new item with id
      const newItem = {
        id: new Date().valueOf(),
        ...ref,
      };
      this.doc.items.push(newItem);
      this.closeDialog();
      //   this.doAutoSave();
    },
    editNote(params) {
      console.log("params", params);
      this.setItem(params);
      this.dialogMode = "edit";
      this.dialog = true;
    },
    deleteNote(params) {
      console.log("params", params);
      this.setItem(params);
      this.dialogMode = "delete";
      this.dialog = true;
    },
    deleteNoteConfirm() {
      this.doc.items.splice(this.cardIndex, 1);
    },
    updateNote(ref) {
      this.$set(this.doc.items, this.cardIndex, ref);
      this.closeDialog();
      this.doAutoSave();
    },
    saveNormalise(params) {
      this.doc.normaliseX = params.x;
      this.doc.normaliseY = params.y;
    },
    updatedCoords(params) {
      const item = this.doc.items.find((x) => x.id === params.id);
      const cardIndex = this.doc.items.indexOf(item);
      const updatedItem = {
        ...item,
        x: params.x,
        y: params.y,
      };
      this.$set(this.doc.items, cardIndex, updatedItem);
      this.modify++;
    },
    updatedLngLat(params) {
      const item = this.doc.items.find((x) => x.id === params.m.id);
      const cardIndex = this.doc.items.indexOf(item);
      const updatedItem = {
        ...item,
        position: params.p,
      };
      this.$set(this.doc.items, cardIndex, updatedItem);
      this.modify++;
    },
    showNote(params) {
      this.setItem(params);
      this.dialogMode = "show";
      this.dialog = true;
    },
    setItem(params) {
      const item = this.doc.items.find((x) => x.id === params.id);
      this.cardIndex = this.doc.items.indexOf(item);
      this.cardId = params.id;
      this.item = Object.assign({}, item);
    },
    cancel() {
      this.closeDialog();
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      if (this.doc) {
        Object.entries(arr).forEach(([outerKey, value]) => {
          if (typeof value === "object") {
            Object.entries(value).forEach(([key, value]) => {
              this.doc[outerKey][key] = value;
            });
          }
          if (typeof value === "string") {
            this.doc[outerKey] = value;
          }
          if (typeof value === "boolean") {
            this.doc[outerKey] = value;
          }
        });
      } else {
        this.doc = arr;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
      this.item = { ...defaults };
      this.$set(this.item, "subitems", []);
    },
    doAutoSave() {
      if (this.autoSave) {
        this.saveState = true;
      }
    },
    filterListType(list) {
      const arr = [...list];
      if (this.filters.zones != "" && this.filters.zones.length != "") {
        // console.log("filter on both");
        return arr.filter(
          (x) =>
            x.categories.includes(this.filters.categories) &&
            x.zones.includes(this.filters.zones)
        );
      } else if (this.filters.zones != "") {
        // console.log("filter on zones");
        return arr.filter((x) => x.zones.includes(this.filters.zones));
      } else if (this.filters.categories != "") {
        // console.log("filter on categories");
        return arr.filter((x) =>
          x.categories.includes(this.filters.categories)
        );
      } else {
        return arr;
      }
    },
  },
};
</script>

<style lang="scss">
.sticky {
  position: sticky;
  top: 80px;
}
</style>
